import { ClassFlag } from "../../dom-tools/ClassFlag";
import { EventSlot } from "../../events/EventSlot";
import { EventListenerCache, EventListenerClass } from "../basics/EventListenerCache";
import { UIListProperty } from "../basics/UIListProperty";
import { UIComponent } from "../components/UIComponent";
import { GraphicalElement } from "./GraphicalElement";

export class LinkedGraphicalElementList<T extends GraphicalElement>extends UIListProperty<T>
{
  protected _parent:UIComponent;
  get parent(){ return this._parent; }

  protected _events = new EventListenerCache();
  protected _callbacks:(( t:T, events:EventListenerCache )=>void)[] = [];
  protected _flags:ClassFlag[] = [];
  protected _parentContainer:HTMLElement;



  constructor( parent:UIComponent, ...flags:ClassFlag[] )
  {
    super( parent );
    this._parent = parent;
    this._parent._addLinkedGraphicalElementList( this );
    this._flags = flags;  

    this._addListeners();
  }

  protected _addListeners()
  {
    this.addListener(
      ( e ) =>
      {
        this._events.remove();

        this._parentContainer.innerHTML = "";

        this.forAll( 
          g => 
          {
            this._parentContainer.appendChild( g.element ) 
            this._flags.forEach( f => f.set( g.element ) );
            this._callbacks.forEach( cb => cb( g, this._events ) );  
          }
        );

        this._parent.redraw();
      }
    );
  }

  _setParentContainer( parent:UIComponent, element:HTMLElement )
  {
    if ( this._parent !== parent )
    {
      return;
    }
    
    this._parentContainer = element;
    this._flags.forEach( f => f.set( this._parentContainer ) );
  }

  addCallback( cb:(t:T, events:EventListenerCache )=>void )
  {
    this._callbacks.push( cb );  
  } 

  onSlot<U>( getTarget:(t:T )=>EventSlot<U>, callback:(u?:U)=>void )
  {
    this.addCallback(
      ( t, events )=>
      {
        let target = getTarget( t );
        events.onSlot( target, callback );
      }
    );
  }

  on<E>( type:EventListenerClass<E>, callback:(e:E)=>void )
  {
    this.addCallback(
      ( t, events )=>
      {
        events.onListener( type, t.element, callback );
      }
    );
  }
}